import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Tagline from '../components/Tagline';
import Clients from '../components/Clients';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Tagline />
      <Clients />
      <Footer />
    </div>
  );
};

export default Home;